import React from "react";
import TabLayout from "../../helpers/TabLayout";
import ConfirmationContainer from "../../helpers/ConfirmationContainer";
import useInfoSnackbar from "../../../hooks/useInfoSnackbar";
import {
  adminPrivacy,
  adminRecompute,
  adminReindex,
  adminTerms,
} from "../../../api/admin";
import { Button, Stack, styled } from "@mui/material";

const StyledStack = styled(Stack)`
  gap: 2em;
`;

const OperationsTab = () => {
  const infoSnackbar = useInfoSnackbar();

  const onOperationConfirmed = async (operation) => {
    const response = await operation();
    if (response.code === "SUCCESS") {
      infoSnackbar.alertSuccess(response.message);
    } else {
      infoSnackbar.alertError(response.message);
    }
  };

  const onReindexConfirmed = async () => onOperationConfirmed(adminReindex);
  const onRecomputeConfirmed = async () => onOperationConfirmed(adminRecompute);
  const onTermsConfirmed = async () => onOperationConfirmed(adminTerms);
  const onPrivacyConfirmed = async () => onOperationConfirmed(adminPrivacy);

  return (
    <TabLayout headerLabel="Operations">
      <StyledStack>
        <ConfirmationContainer
          dialogTitle="Confirm Reindex"
          dialogMessage="Are you sure that you want to reindex?"
          onConfirmed={onReindexConfirmed}
        >
          <Button>Reindex</Button>
        </ConfirmationContainer>
        <ConfirmationContainer
          dialogTitle="Confirm Recompute"
          dialogMessage="Are you sure that you want to recompute?"
          onConfirmed={onRecomputeConfirmed}
        >
          <Button>Recompute</Button>
        </ConfirmationContainer>
        <ConfirmationContainer
          dialogTitle="Confirm Send Terms of Use"
          dialogMessage="Are you sure that you want to send Terms of Use update notifications?"
          onConfirmed={onTermsConfirmed}
        >
          <Button>Send Terms of Use Update Notifications</Button>
        </ConfirmationContainer>
        <ConfirmationContainer
          dialogTitle="Confirm Send Privacy Policy"
          dialogMessage="Are you sure that you want to send Privacy Policy update notifications?"
          onConfirmed={onPrivacyConfirmed}
        >
          <Button>Send Privacy Policy Update Notifications</Button>
        </ConfirmationContainer>
      </StyledStack>
    </TabLayout>
  );
};

export default OperationsTab;